import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';

// Bootstrap components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Tab from 'react-bootstrap/Tab';
import Modal from 'react-bootstrap/Modal';
import Tabs from 'react-bootstrap/Tabs';

// Marketplace / Modal icons
import marketplaceOpenseaIcon from '../../assets/icons/marketplace-opensea.png';
import marketplaceLooksrareIcon from '../../assets/icons/marketplace-looksrare.png';
import marketplaceGemIcon from '../../assets/icons/marketplace-gem.png';

// Image with spinner
import ImageWithSpinner from '../shared/ImageWithSpinner';

// Custom Icons Bootstrap
import { Download } from 'react-bootstrap-icons';

// Number formating
import { Button } from 'react-bootstrap';

// Spinning wheel
import {ReactSpinner} from 'react-spinning-wheel';
import 'react-spinning-wheel/dist/style.css';

// Context modules
import { useSharedGlobalState } from "../../shared/GlobalState";

// Recharts
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// You can style your pagination component
// thanks to styled-components.
// Use inner class names to style the controls.
const MyPaginate = styled(ReactPaginate).attrs({
    // You can redefine classes here, if you want.
    activeClassName: 'active', // default to "selected"
  })`
    margin: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style-type: none;
    padding: 0 5rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
    }
    li.previous a,
    li.next a,
    li.break a {
      border-color: transparent;
    }
    li.active a {
      background-color: #0366d6;
      border-color: transparent;
      color: white;
      min-width: 32px;
    }
    li.disabled a {
      color: grey;
    }
    li.disable,
    li.disabled a {
      cursor: default;
    }
  `;

// currentItems: the items to display
// metadata: the array that contain metadata related to the items to display
// fileDirectory: the directory where the asset are located
function Items({ pageNumber, currentItems, metadata, fileDirectory, openAssetDetailsModal }) {

  // console.log("Items pageNumber=" + pageNumber);
    
  return (

    <div className="row align-items-center">
        { currentItems !== null ? (

            <>
            {currentItems.map((d, index) => (

                <Col className="justify-content-center">
                    <Row className="justify-content-center">
                        <span><strong>{metadata[d].name}</strong></span>
                    </Row>
                    <Row className="justify-content-center">
                        <ImageWithSpinner
                            className="search-result-thumbnail"
                            alt={metadata[d].name}
                            title={metadata[d].name}
                            src={fileDirectory + metadata[d].fileName}
                            onClick={() => openAssetDetailsModal(metadata[d].tokenId)}
                            page={pageNumber}
                            height={200} 
                            // width={200} 
                        />
                    </Row>
                </Col>
            ))}
            </>

        ) : (
            <Col className="d-flex flex-column align-items-center col-lg-12">
                <div className=""><ReactSpinner /><strong>Loading data...</strong></div>
            </Col>
        )}

    </div> 

  );
}

function PaginatedItems({ collectionName, itemsPerPage, data, metadata, collectionFileHighResDirectory, collectionFileThumbnailsDirectory }) {

  // data: the data object 
  // itemsPerPage: nb of items to display per page

  // currentItems: items slices to be displayed on the current page 

  // Global states
  const { 
    HOPEANDSEA_SERVER_URL, HOPENANDSEA_API_KEY
  } = useSharedGlobalState();

  // ASSET DETAILS MODAL 
  const [assetDetailsInfo, setAssetDetailsInfo] = useState([]);
  const [assetModalShow, setAssetModalShow] = useState(false);
  const handleAssetModalClose = () => setAssetModalShow(false);
  const handleAssetModalShow = () => setAssetModalShow(true);

  // Page navigation details
  const [currentPageNumber, setCurrentPageNumber] = useState(0);

  // Recharts library 
  const [chartData, setChartData] = useState(null);

    /**
     * Display the details about modals 
     * 
     * @param {} assetTokenId 
     */
     function openAssetDetailsModal(assetTokenId) {
        //console.log("INSINE openAssetDetailsModel");
        setAssetDetailsInfo(null);
        handleAssetModalShow();
        fetchAssetDetails(assetTokenId);
    }

    async function fetchAssetDetails(assetTokenId) {

        const hostname = HOPEANDSEA_SERVER_URL;
        let fetchUrl = null; let jsonData = null

        const formData = new FormData();
        formData.append("X-API-KEY", HOPENANDSEA_API_KEY);

        fetchUrl = hostname + "/api/v1/getAssetDetailsForCollection.php?collection=" + collectionName + "&tokenId=" + assetTokenId;
        jsonData = await fetch(fetchUrl, {method: 'POST', body: formData})
            .then(response => response.json());
        // NOTE - We are assuming fetch return results!
        if (jsonData.length === 0) {
            // TODO Handle error here
            console.err("No data retrieve from fetch call: " + fetchUrl);
        } else {
            const data = jsonData.data.data;
            data.openseaLastRefreshDate = jsonData.data.openseaLastRefreshDate;
            data.feedGenerationDate = jsonData.data.feedGenerationDate;
            data.serverAppVersion = jsonData.data.appVersion;
            //console.log(jsonData);
            setAssetDetailsInfo(data);

            let chartData = [];
            if (data.assetSale_history) {
                for (var i=0; i<data.assetSale_history.length; i++) {
                    const salesData = data.assetSale_history[i];
                    // The first entry will be the mint entry, for which the price is not known 
                    if (i === 0) {
                        chartData[i] = {
                            name: salesData.created_date.substr(0, 10),
                            price: data.collection_mintPrice,
                            amt: data.collection_mintPrice,
                        }
                    } else {
                        chartData[i] = {
                            name: salesData.created_date.substr(0, 10),
                            price: salesData.transaction_price,
                            amt: salesData.transaction_price,
                        }
                    }
                }
            }
            setChartData(chartData);
            //console.log("chartData=", chartData);
        }
    }

  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + itemsPerPage;
  console.log("PaginatedItems: Data: " , data);
  console.log("PaginatedItems: Loading items from ${itemOffset} to ${endOffset}");
  //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = data.slice(itemOffset, endOffset);
  console.log("PaginatedItems: Current page data: " , currentItems);
  // Total number of pages 
  const pageCount = Math.ceil(data.length / itemsPerPage);
  

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
    setCurrentPageNumber(event.selected);
  };

  /**
   * function to open a link in a new tab
   * @param {*} link the link to open
   */
  const openLinkInNewTab = (link) => {
    window.open(link, "_blank");
  }

  const downloadLinkToDevice = (link, filename) => {

    fetch(link, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/png',
        },
      })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          filename,
        );
    
        // Append to html link element page
        document.body.appendChild(link);
    
        // Start download
        link.click();
    
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });

  }

  return (
    <>

      
      {/* Display the pagination controls */}
      <MyPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />

      {/* Display the results  */}
      <Items pageNumber={currentPageNumber} currentItems={currentItems} metadata={metadata} fileDirectory={collectionFileThumbnailsDirectory} openAssetDetailsModal={openAssetDetailsModal} />

        {/* ASSET DETAILS MODAL */}
        <Modal size="xl" show={assetModalShow} onHide={handleAssetModalClose}>

        {assetDetailsInfo !== null ? (

            <>

                <Modal.Header>
                <Modal.Title>{assetDetailsInfo.asset_name} (from {assetDetailsInfo.collection_name})</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                        <Tabs defaultActiveKey="story" className="mb-3">

                            <Tab eventKey="story" title="Asset Story">

                            <Row>
                                <Col className="col-3">
                                    <a target="_blank" rel="noreferrer" href={assetDetailsInfo.asset_openseaLink}>
                                        <img
                                            className="img-fluid"
                                            alt={assetDetailsInfo.asset_name}
                                            title={assetDetailsInfo.asset_name}
                                            src={collectionFileHighResDirectory + collectionName + "_" + assetDetailsInfo.asset_tokenId + ".png"} />
                                    </a>
                                </Col>
                                <Col className="col-9">

                                    <Row><Col>
                                    👋 <strong>My name is {assetDetailsInfo.asset_name}</strong> and it is nice to meet you!
                                    </Col></Row>

                                    {/* <br/>
                                    <Row><Col>🎂 Today I am {assetDetailsInfo.assetAge_years} year(s), {assetDetailsInfo.assetAge_months} month(s), and {assetDetailsInfo.assetAge_days} day(s) old!
                                    My birthday is coming up in {assetDetailsInfo.assetNextBirthday_years}, year(s), {assetDetailsInfo.assetNextBirthday_months} month(s), and {assetDetailsInfo.assetNextBirthday_days} day(s) and I am super excited about it!
                                    </Col></Row> */}
                                    
                                    <br/>
                                    { assetDetailsInfo.traits_details !== undefined && (
                                        <Row><Col><span>😂 Here are some fun facts about me:</span>
                                            <ul>
                                                {assetDetailsInfo.traits_details.map((traitData, index) => (
                                                    <>

                                                        { collectionName === "goodmorningcafe" && (

                                                            <>

                                                            { traitData.name === "background" && (<li>My favorite color is <strong>{traitData.value}</strong>.</li>)}
                                                            { traitData.name === "colour" && (<li>My second favorite color is <strong>{traitData.value}</strong>.</li>)}
                                                            { traitData.name === "mood" && (<li>I love <strong>{traitData.value}</strong>.</li>)}
                                                            { traitData.name === "clothing" && (<li>I often wear <strong>{traitData.value}</strong>.</li>)}
                                                            { traitData.name === "object" && (<li>Did you noticed my <strong>{traitData.value}</strong>?</li>)}

                                                            </>

                                                        )}

                                                        { collectionName === "squeakersnft" && (

                                                        <>

                                                        { traitData.name === "background" && (<li>My favorite color is <strong>{traitData.value}</strong>.</li>)}
                                                        { traitData.name === "body" && (<li>My second favorite color is <strong>{traitData.value}</strong>.</li>)}
                                                        { traitData.name === "aura" && (<li>My aura is <strong>{traitData.value}</strong>.</li>)}
                                                        { traitData.name === "bodysuit" && (<li>I often wear <strong>{traitData.value}</strong>.</li>)}
                                                        { traitData.name === "ear" && (<li>My ears are <strong>{traitData.value}</strong>.</li>)}
                                                        { traitData.name === "eyes" && (<li>People like my eyes because they looks <strong>{traitData.value}</strong>.</li>)}
                                                        { traitData.name === "head" && (<li>I have a <strong>{traitData.value}</strong> head.</li>)}
                                                        { traitData.name === "month" && (<li>Did you noticed that I have <strong>{traitData.value}</strong> in my month!</li>)}

                                                        </>

                                                        )}

                                                        { collectionName === "whiskersnft" && (

                                                        <>

                                                        { traitData.name === "face" && (<li>Did you noticed my <strong>{traitData.value}</strong> face?</li>)}
                                                        { traitData.name === "facial feature" && (<li>I also have a <strong>{traitData.value}</strong> facial trait</li>)}
                                                        { traitData.name === "inventory" && (<li>I love to carry in my inventory a <strong>{traitData.value}</strong></li>)}
                                                        { traitData.name === "equipment" && (<li>I love my <strong>{traitData.value}</strong></li>)}
                                                        { traitData.name === "origin" && (<li>My origin is <strong>{traitData.value}</strong></li>)}
                                                        { traitData.name === "species" && (<li>I am part of the <strong>{traitData.value}</strong> species</li>)}

                                                        </>

                                                        )}

                                                    </>
                                                ))}
                                            </ul>
                                        </Col></Row>
                                    )}
                                </Col>
                            </Row>

                            </Tab>

                            <Tab eventKey="rarity" title="Asset Rarity">
                                
                                <Row>
                                    <Col className="col-3">
                                        <a target="_blank" rel="noreferrer" href={assetDetailsInfo.asset_openseaLink}>
                                            <img
                                                className="img-fluid"
                                                alt={assetDetailsInfo.asset_name}
                                                title={assetDetailsInfo.asset_name}
                                                src={collectionFileHighResDirectory + collectionName + "_" + assetDetailsInfo.asset_tokenId + ".png"}/>
                                        </a>
                                    </Col>
                                    <Col className="col-9">
                                        <Row>
                                            <Col className="col-12">
                                                <strong>{assetDetailsInfo.asset_name}</strong> 
                                            </Col>
                                        
                                        </Row>
                                        <Row className="mb-4">
                                            <Col className="col-12">
                                                <strong>Rank #{assetDetailsInfo.rarity_rank}</strong> (Rarity score: {assetDetailsInfo.rarity_score})
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col className="col-3"><strong>Trait Name</strong></Col>
                                            <Col className="col-3"><strong>Trait Value</strong></Col>
                                            <Col className="col-3"><strong>Trait Score</strong></Col>
                                            <Col className="col-3"><strong>Trait Occurences</strong></Col>
                                        </Row>

                                        { assetDetailsInfo.traits_details !== undefined && (

                                        <>
                                            {assetDetailsInfo.traits_details.map((traitData, index) => (
                                                <Row>
                                                    <Col className="col-3">{traitData.name}</Col>
                                                    <Col className="col-3">{traitData.value}</Col>
                                                    <Col className="col-3">{traitData.score}</Col>
                                                    <Col className="col-3">{traitData.occurences}</Col>
                                                </Row>
                                            ))}
                                        

                                            <Row>
                                                <Col className="col-3"></Col>
                                                <Col className="col-3"><strong>Total Rarity Score</strong></Col>
                                                <Col className="col-3"><strong>{assetDetailsInfo.rarity_score}</strong></Col>
                                                <Col className="col-3"></Col>
                                            </Row>

                                        </>

                                        )}
                                    
                                    </Col>

                                </Row>

                            </Tab>

                            {/* <Tab eventKey="sales" title="Market Sales">

                                <Row>
                                    <Col className="col-3">
                                        <a target="_blank" rel="noreferrer" href={assetDetailsInfo.asset_openseaLink}>
                                            <img
                                                className="responsive"
                                                alt={assetDetailsInfo.asset_name}
                                                title={assetDetailsInfo.asset_name}
                                                src={assetDetailsInfo.assetImage_preview}/>
                                        </a>
                                    </Col>
                                    <Col className="col-9">
                                        <Row>
                                            <Col className="col-9">
                                                {(assetDetailsInfo.assetSale_date === null) ? (
                                                    <>Can you believe that this asset has never been sold!!!</>
                                                ) : (
                                                    <>Last sold on {assetDetailsInfo.assetSale_date}, 
                                                    from <a target="_blank" rel="noreferrer" href={assetDetailsInfo.assetSale_toUser_openseaProfileUrl}>{assetDetailsInfo.assetSale_toUser_name}</a>
                                                    <span> </span>to <a target="_blank" rel="noreferrer" href={assetDetailsInfo.assetSale_fromUser_openseaProfileUrl}>{assetDetailsInfo.assetSale_fromUser_name}</a> for {assetDetailsInfo.assetSale_price} ETH</>
                                                )}
                                            </Col>
                                            <Col className="col-3">
                                                Buy on: <a target="_blank" rel="noreferrer" href={assetDetailsInfo.asset_openseaLink} className=""><img alt="Opensea icon" height={30} src={marketplaceOpenseaIcon} title="Opensea marketplace"/></a> <a target="_blank" rel="noreferrer" href={assetDetailsInfo.asset_looksrareLink} className=""><img alt="Looksrare Icon" height={30} src={marketplaceLooksrareIcon} title="LooksRare marketplace"/></a> <a target="_blank" rel="noreferrer" href={assetDetailsInfo.asset_gemxyzLink} className=""><img height={30} alt="GemXYZ Icon" src={marketplaceGemIcon} title="Gem marketplace"/></a>
                                            </Col>
                                        
                                        </Row>
                                        <Row>
                                            <Col>
                                            Sales history:
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Container width="100%" height="100%">
                                                <LineChart
                                                    width={800}
                                                    height={200}
                                                    data={chartData}
                                                    margin={{
                                                        top: 5,
                                                        right: 30,
                                                        left: 20,
                                                        bottom: 5,
                                                    }}
                                                    >
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <XAxis dataKey="name" />
                                                    <YAxis dataKey="price" />
                                                    <Tooltip />
                                                    <Legend />
                                                    <Line type="monotone" dataKey="price" stroke="purple" />
                                                </LineChart>
                                            </Container>

                                        </Row>

                                    </Col>
                                </Row>
                                
                            </Tab> */}
                            
                        </Tabs>


                        {/* <Alert variant={"warning"} className="mt-2">The information on this page is based on Opensea data and is up to date as of {assetDetailsInfo.openseaLastRefreshDate} UTC</Alert> */}

                        <Row >
                            <Col className="d-flex justify-content-end">
                                <Button title="Check this NFT on Opensea" className="m-1" variant="light" onClick={() => openLinkInNewTab(assetDetailsInfo.asset_openseaLink)}><img width="20" src={marketplaceOpenseaIcon} /></Button>
                                <Button title="Check this NFT on LooksRare" className="m-1" variant="light" onClick={() => openLinkInNewTab(assetDetailsInfo.asset_looksrareLink)}><img width="20" src={marketplaceLooksrareIcon} /></Button>
                                <Button title="Check this NFT on Gem" className="m-1" variant="light" onClick={() => openLinkInNewTab(assetDetailsInfo.asset_gemxyzLink)}><img width="20" src={marketplaceGemIcon} /></Button>
                                <Button title="Download a high-res version of this NFT" className="m-1" variant="light" onClick={() => downloadLinkToDevice(collectionFileHighResDirectory + collectionName + "_" + assetDetailsInfo.asset_tokenId + ".png", collectionName + "-" + assetDetailsInfo.asset_tokenId + ".png")}><Download /></Button>
                            </Col>
                        </Row>


                        </Modal.Body>
                    <Modal.Footer>
                    
                    <Button variant="secondary" onClick={handleAssetModalClose}>OK</Button>
                    </Modal.Footer>

                </>

                ) : (

                    <>

                    <Modal.Header>
                    <Modal.Title>Loading...</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                            <Row className="justify-content-center">
                                <div className=""><ReactSpinner /><strong>Loading data...</strong></div>
                            </Row>

                            </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAssetModalClose}>OK</Button>
                    </Modal.Footer>

                    </>

                )}

            
        </Modal>

    </>
  );
}

export default PaginatedItems;